import { Input } from "antd";
import { rgba, cssVar } from "polished";
import styled from "styled-components";

const colorsHelper = () => {
  const defaultValue = "#fff";
  return {
    "--color-brand-100": cssVar("--color-brand-100", defaultValue),
    "--color-neutral-600": cssVar("--color-neutral-600", defaultValue),
    "--opacity-level-5": cssVar("--opacity-level-5", defaultValue),
    "--opacity-level-2": cssVar("--opacity-level-2", defaultValue),
  };
};

export const SearchInput = styled(Input)`
  margin-bottom: 10px;
  width: 300px;
  min-height: ${(props) => props.theme["@height-button-lg"]} !important;
  .ant-input-affix-wrapper {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    :hover {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
      background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))};
    }
  }

  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:focus {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    outline: 1.6px solid ${(props) => props.theme.colors.text} !important;
    box-shadow: none !important;
    outline-offset: 1.6px !important;
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
  }

  .ant-input-clear-icon {
    color: ${() => rgba(colorsHelper()["--color-neutral-600"], Number(colorsHelper()["--opacity-level-2"]))};
    font-size: ${(props) => props.theme["@large-font-size"]};
  }

  .anticon.anticon-search {
    font-size: 20px;
    color: ${() => rgba(colorsHelper()["--color-neutral-600"], Number(colorsHelper()["--opacity-level-2"]))};
    cursor: pointer;
  }
`;
